import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";


const PortfolioProjectCardLeft = ({
    // imageSrc,
    images, 
    title,
    description,
    logoSrc,
    heading,
    link
}) => {
    return (
        <div className="flex flex-col md:flex-row items-center justify-start text-black overflow-hidden max-w-[1200px] m-auto my-10">
            {/* Left: Image */}
            <div className="md:w-1/2 w-full">
                <Swiper
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                >
                    {images.map((image, index) => (
                        <SwiperSlide key={index}>
                            <img
                                src={image}
                                alt={`${title} ${index}`}
                                className="object-fill w-full h-[400px]"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* Right: Text Content */}
            <div className="md:w-1/2 w-full space-y-4 justify-start text-left px-16 p-10">
                <img
                    src={logoSrc}
                    alt={title}
                    className="object-contain w-20 h-20 rounded-full bg-white"
                />
                <p className="text-sm uppercase tracking-widest text-gray-600">{heading}</p>
                <h2 className="text-2xl font-bold leading-normal">{title}</h2>
                <p className="text-black">{description}</p>
                <a
                    href={link}
                    className=" mt-2 text-[--bg-color]  transition flex items-center"
                >
                    View <MdKeyboardDoubleArrowRight />

                </a>
            </div>
        </div>
    );
};

export default PortfolioProjectCardLeft;
